import { defineMessages } from 'react-intl';

export const appBlurbMessages = {
  medication: defineMessages({
    title: {
      defaultMessage: 'Prescribed medication',
    },
  }),
  progressTrack: defineMessages({
    title: {
      defaultMessage:
        'Digital Bluetooth Scales to measure, track and celebrate your progress.',
    },
    description: {
      defaultMessage:
        'Seamlessly integrate and track your health markers in one place.',
    },
  }),
  community: defineMessages({
    title: {
      defaultMessage:
        'Exclusive Community Access with 16k+ women sharing tips and support.',
    },
    description: {
      defaultMessage:
        'Join the Juniper Weight Reset Facebook Community and connect with other members.',
    },
  }),
  results: defineMessages({
    title: {
      defaultMessage:
        'Achieve results in 30 days or we’ll refund you, no questions asked.',
    },
    description: {
      defaultMessage: 'Using our 30-day money-back-guarantee.',
    },
  }),
};
